import { Calendar, CalendarChangeParams } from 'primereact/calendar';
import { useId } from 'react-id-generator';
import { EMPTY_FIELD_PLACEHOLDER } from '../../Helper/Statics/Constants';
import BeeTextInput from './BeeTextInput';

import './BeeTimeInput.scss';

type BeeTimeInputProps = {
  label?: string;
  value?: Date;
  disabled?: boolean;
  formstate?: string;
  tabIndex?: number;
  readOnly?: boolean;
  required?: boolean;
  onChange?: (e: CalendarChangeParams) => void;
  onFocusOut?: (e: React.FocusEvent<HTMLInputElement, Element>) => void;
};

export function BeeTimeInput({
  label,
  value,
  disabled,
  formstate,
  tabIndex,
  readOnly,
  required,
  onChange,
  onFocusOut
}: BeeTimeInputProps) {
  const currentId = useId(1, 'bee-date-input-')[0];

  //classNames
  const formStateClassnames =
    formstate === 'valid'
      ? ' bee-date-input-valid'
      : formstate === 'error'
      ? ' bee-date-input-error'
      : formstate === 'neutral'
      ? ' bee-date-input-neutral'
      : ' bee-date-input-neutral';

  let readOnlyClassNames = '';

  if (readOnly) {
    readOnlyClassNames = ' bee-date-input-readOnly';
    disabled = true;
  }
  const classnames =
    'bee-date-input' + formStateClassnames + readOnlyClassNames;
  const containerClassNames = 'p-float-label bee-date-input-container';

  //label
  const labelClassNames = 'bee-date-input-label';

  function change(e: CalendarChangeParams) {
    if (!disabled && onChange) {
      onChange(e);
    }
  }
  function focusOut(e: React.FocusEvent<HTMLInputElement, Element>) {
    if (!disabled && onFocusOut) {
      onFocusOut(e);
    }
  }

  const renderPlaceholder = () => {
    return (
      <BeeTextInput
        label={label}
        value={EMPTY_FIELD_PLACEHOLDER}
        disabled={disabled}
        readOnly={true}
        required={required}
      />
    );
  };

  return (
    <>
      {readOnly && !value ? (
        renderPlaceholder()
      ) : (
        <span id={currentId} className={containerClassNames}>
          <Calendar
            id={currentId + 'input'}
            showTime
            timeOnly
            hourFormat="24"
            value={value}
            disabled={disabled}
            className={classnames}
            onChange={(e) => {
              console.log(e);
              change(e);
            }}
            onBlur={(e) => focusOut(e)}
          ></Calendar>

          {label ? (
            <label htmlFor={currentId + 'input'} className={labelClassNames}>
              {label}
              {required && label ? (
                <span className="bee-date-input-label-required">
                  <span className="bee-date-input-label-required-star"> *</span>
                </span>
              ) : null}
            </label>
          ) : null}
        </span>
      )}
    </>
  );
}

export default BeeTimeInput;
